var _defs, _rect, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationFullBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_185493",
    "data-name": "\\uADF8\\uB8F9 185493",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920.5,
    height: 852,
    viewBox: "0 0 1920.5 852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1879,
    height: 851.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 802.5,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154567",
    "data-name": "\\uC0AC\\uAC01\\uD615 154567",
    width: 1920,
    height: 851,
    fill: "#f1f3f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185175",
    "data-name": "\\uADF8\\uB8F9 185175",
    transform: "translate(41 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uBC18\\uBCF5_\\uADF8\\uB9AC\\uB4DC_45",
    "data-name": "\\uBC18\\uBCF5 \\uADF8\\uB9AC\\uB4DC 45",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-41 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-2",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-3",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-4",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(163 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-5",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(214 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-6",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(265 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-7",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(316 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-8",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(367 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-9",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(418 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-10",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(469 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-11",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-12",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(571 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-13",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(622 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-14",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(673 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-15",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(724 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-16",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-17",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(826 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-18",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(877 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-19",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(928 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-20",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(979 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-21",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1030 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-22",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1081 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-23",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1132 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-24",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1183 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-25",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1234 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-26",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1285 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-27",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1336 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-28",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1387 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-29",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1438 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-30",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1489 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-31",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1540 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-32",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1591 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-33",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1642 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-34",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1693 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-35",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1744 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-36",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1795 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1679-37",
    "data-name": "\\uC120 1679",
    y2: 906,
    transform: "translate(41.5 0.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185174",
    "data-name": "\\uADF8\\uB8F9 185174",
    transform: "translate(0.5 49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uBC18\\uBCF5_\\uADF8\\uB9AC\\uB4DC_46",
    "data-name": "\\uBC18\\uBCF5 \\uADF8\\uB9AC\\uB4DC 46",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -49)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 2)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680-2",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 53)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680-3",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 104)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680-4",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 155)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680-5",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 206)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680-6",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 257)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680-7",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 308)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680-8",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 359)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680-9",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 410)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680-10",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 461)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680-11",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 512)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680-12",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 563)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680-13",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 614)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680-14",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 665)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680-15",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 716)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1680-16",
    "data-name": "\\uC120 1680",
    x2: 1920,
    transform: "translate(0.5 49.5)",
    fill: "none",
    stroke: "#d1e1fe",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationFullBackground);
export default __webpack_public_path__ + "static/media/navigation_full_background.075866b0c5f0686ce816c4addcad2d5e.svg";
export { ForwardRef as ReactComponent };